// src/pages/store/Dashboard.js
import React, { useEffect, useState } from "react";
import api from "../../services/api";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export default function UserDashboard() {
  const [summary, setSummary] = useState({
    balance: 0,
    credit: 0,
    totalRequests: 0,
  });

  useEffect(() => {
    api.get("/store-panel/summary")
      .then(res => {
        setSummary({
          balance: res.data.balance,        // فرض بر این است پاسخ دارای این فیلدهاست
          credit: res.data.credit,
          totalRequests: res.data.requestsCount || 0,
        });
      })
      .catch(err => {
        console.error("Failed to fetch summary:", err);
        // می‌تونی Toast یا خطا نشون بدی
      });
  }, []);

  return (
    <div>
      <h3 className="mb-4">داشبورد کاربر</h3>
      <Row xs={1} md={3} className="g-3">
        <Col>
          <Card className="shadow-sm">
            <Card.Body>
              <Card.Title>موجودی کیف پول</Card.Title>
              <Card.Text className="fs-4 fw-bold text-success">
                {summary.balance.toLocaleString()}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="shadow-sm">
            <Card.Body>
              <Card.Title>اعتبار</Card.Title>
              <Card.Text className="fs-4 fw-bold text-primary">
                {summary.credit.toLocaleString()}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card className="shadow-sm">
            <Card.Body>
              <Card.Title>تعداد درخواست‌ها</Card.Title>
              <Card.Text className="fs-4 fw-bold text-warning">
                {summary.totalRequests.toLocaleString()}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
